export default {
  show: {
    display: 'block'
  },
  hide: {
    display: 'none'
  },
  box: {
    width: '100%',
    height: '100%',
  },
  loadContainer: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    zIndex: '9999',
  },
  tirtle: {
    width: '100%',
    textAlign: 'center',
    padding: '10px 10px',
    borderBottom: '1px solid #eee',
    boxSizing: 'border-box'
  },
  content: {
    width: '100%',
    padding: '10px 10px',
    borderBottom: '1px solid #eee',
    boxSizing: 'border-box'
  },
  boxbg: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'fixed',
    width: '100%',
    height: '100%',
    zIndex: '999',
    top: '0',
    left: '0',
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  megGroup: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    left: '0%',
    zIndex: '9999',
  },
  disabled: {
    cursor: 'not-allowed',
    border: '1px solid #ddd',
    borderColor: '#ddd',
    backgroundColor: '#ddd',
    color: '#aaa'
  },
  leftCon: {
  },
  rightX: {
    position: 'absolute',
    right: '10px',
    top: '5px',
    cursor: 'pointer'
  },
  container: {
    display: 'inline-block',
    padding: '10px',
    margin: '10px 10px'
  },
  spanb: {
    margin: '5px 5px',
    float: 'left',
    padding: '10px',
    backgroundColor: '#ddd',
  },
  marginRight: {
    marginRight: '1rem'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Loader/style.js